import React from 'react';

import * as Styled from './styles';
import { SectionWrapperProps } from './types';
import { SectionBackgroundMode, SectionGutterMode } from './enums';
import theme from '../../../theme';

const Section: React.FC<SectionWrapperProps> = ({
  children,
  backgroundMode = SectionBackgroundMode.Default,
  isFullWidth = false,
  gutterTop = SectionGutterMode.Small,
  gutterBottom = SectionGutterMode.Small,
}) => (
  <Styled.Section
    maxWidth={isFullWidth ? '100%' : '120rem'}
    pt={theme.spacing[gutterTop]}
    pb={theme.spacing[gutterBottom]}
    {...{ backgroundMode }}
  >
    {children}
  </Styled.Section>
);

export default Section;
